import { ToastId, ToastPosition, useToast } from "@chakra-ui/react";
import { useCallback } from "react";

import { useIsMobile } from ".";
import { MessageAlert, MessageAlertProperties } from "../components/";

export interface MessageToastProperties extends Omit<MessageAlertProperties, "position"> {
  isClosable?: boolean;
  onCloseCallBack?: () => void;
  position?: ToastPosition;
  shouldDismiss?: boolean;
}

export const useMessageToast = (): ((options: MessageToastProperties) => ToastId | undefined) => {
  const toast = useToast();
  const isMobile = useIsMobile();

  return useCallback(
    ({ isClosable = true, onCloseCallBack, position, shouldDismiss = true, ...rest }: MessageToastProperties) =>
      toast({
        duration: shouldDismiss ? 5000 : null,
        isClosable,
        position: position ?? (isMobile ? "bottom" : "top"),
        render: ({ onClose }) => (
          <MessageAlert
            boxShadow="lg"
            data-testid="toast"
            onClose={
              isClosable
                ? () => {
                    onClose();
                    onCloseCallBack?.();
                  }
                : undefined
            }
            {...rest}
          />
        ),
      }),
    [toast, isMobile],
  );
};
